export const CAMPAIGN_REPORTS_ROUTE = "/campaign-reports";
